module.exports = __webpack_public_path__ + "img/IGUIBetav9.cc603209.svg";